import { produce } from "immer";
import { PhysicalObjectInterface } from "../ts/app_interfaces";

// Offset applied to a duplicated / pasted object so the copy is visibly
// distinct from its source. Shared by header Copy, Cmd+V and bulk duplicate so
// a set of objects keeps its relative layout when copied together.
export const DUPLICATE_OFFSET: [number, number, number] = [3, 3, 3];

// Clone a board object with a fresh key and an offset position. Pure and
// three-free: importable from MattoState (boot path) and from tests.
export function cloneWithOffset(
  physicalObject: PhysicalObjectInterface | any,
  offset: [number, number, number] | number[] = DUPLICATE_OFFSET,
): PhysicalObjectInterface {
  let scale = physicalObject.scale ?? [1, 1, 1];
  if (Array.isArray(scale) === false) scale = [scale, scale, scale];
  const position = physicalObject.position ?? [0, 0, 0];
  return produce(physicalObject, (draft: any) => {
    draft.key = Math.random();
    draft.scale = scale.map((x: number) => x * 1);
    draft.rotation = physicalObject.rotation ?? [0, 0, 0];
    draft.position = [
      position[0] + offset[0],
      position[1] + offset[1],
      position[2] + offset[2],
    ];
  });
}
